import { FC, useEffect } from 'react';
import { Col, Row } from 'antd';

import { getBalance, getDocuments } from 'features/overview/actions';

import { Wallet } from './Wallet';
import { ProfitStatus } from './ProfitStatus';
import { Balance } from './Balance';
import { LoyaltyStatus } from './LoyaltyStatus';
import { Investments } from './Investments';
import { AgreeWithTerms, RejectedMessage } from 'componets/ui';
import { BearLossCalculator } from './BearLossCalculator';

import { useAppDispatch, useAppSelector } from 'hooks';

import { RequestStatus, SECOND } from 'utils/constants';

import './index.scss';
import { selectUser } from '../../../selectors';

export const Overview: FC = () => {
	const { status, timeBalanceLoaded } = useAppSelector((state) => state.overview);
	const user = useAppSelector(selectUser);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (!timeBalanceLoaded || new Date().getTime() - timeBalanceLoaded > SECOND) {
			dispatch(getBalance());
		}
	}, [dispatch, timeBalanceLoaded]);

	useEffect(() => {
		dispatch(getDocuments());
	}, [dispatch]);

	const isLoading = status === RequestStatus.PENDING;
	const isRejected = status === RequestStatus.REJECTED;

	return (
		<>
			{!isRejected && (
				<Row gutter={[32, 24]} className="overview-col-order">
					<Col className="gutter-row" xl={8} md={12} sm={24} xs={24}>
						<Balance isLoading={isLoading} />
					</Col>
					<Col className="gutter-row" xl={8} md={12} sm={24} xs={24}>
						<Wallet isLoading={isLoading} />
					</Col>
					<Col className="gutter-column" xl={8} md={12} sm={24} xs={24}>
						<LoyaltyStatus isLoading={isLoading} />
						<div className="gutter-row-tablet">
							<BearLossCalculator />
						</div>
					</Col>
					<Col className="gutter-row gutter-row-tablet" xl={8} md={12} sm={24} xs={24}>
						<Investments isLoading={isLoading} />
					</Col>
					<Col className="gutter-row" xl={16} md={24} sm={24} xs={24}>
						<ProfitStatus />
					</Col>
					<Col className="gutter-column" xl={8} md={24} sm={24} xs={24}>
						<div className="gutter-column-desktop">
							<Investments isLoading={isLoading} />
							<BearLossCalculator />
						</div>
					</Col>
				</Row>
			)}
			{isRejected && <RejectedMessage />}
			{!user.agreeWithTerms && <AgreeWithTerms />}
		</>
	);
};
